import { api } from "./api";
import { convertToCamel } from "@lib/convertToCamel";
import { Ad } from "@dto/Ad";
import i18n from "../../i18n/i18n";

export const adApi = api.injectEndpoints({
  overrideExisting: true,
  endpoints: (build) => ({
    getAds: build.query<Ad[], void>({
      query: () => {
        const url = `/ads`;

        return {
          url: url,
          params: {
            cache_version: VisitWidget.settings.adsCacheVersion,
            locale: i18n.language,
          },
        };
      },
      transformResponse: (responseData) => {
        if (!VisitWidget.settings.adsOn) {
          return [];
        }

        const ads = convertToCamel(responseData) as Ad[];
        ads.forEach((ad) => {
          ad.type = "Ad";
        });

        return ads;
      },
      providesTags: (_search, _err, _request) => [
        {
          type: "Ad",
        },
      ],
    }),
  }),
});

export const { useGetAdsQuery } = adApi;

export const {
  endpoints: { getAds },
} = adApi;
